import createVIAlignmentPlugin from "./createVIAlignmentPlugin";

export default createVIAlignmentPlugin;
